const support = (request, api_config) => {
  const prefix = 'Support'

  const CreateScanQRCode = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/CreateScanQRCode`,
      method: 'get',
      params: data
    })
    return result
  }

  const GetStations = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetStations`,
      method: 'get',
      params: data
    })
    return result
  }

  return {
    CreateScanQRCode,
    GetStations
  }
}

export default support
